/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chevron_up_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5 15.5 7-7 7 7"
    />
  </svg>
)
export default chevron_up_medium
